export default __webpack_public_path__ + "images/dhl-1-logo-png-transparent.png";